import React, { useRef } from "react";
import { Button } from "@blueprintjs/core";
export function ImageToolbar({ canvas }) {
   const fileInputRef = useRef();

   const handleReplaceClick = () => {
     fileInputRef.current?.click();
   };

   const handleReplaceImage = (event) => {
     const file = event.target.files[0];
     if (!file || !canvas) return;

     const activeObject = canvas.getActiveObject();
     const reader = new FileReader();
     reader.onload = (e) => {
       const newImageURL = e.target.result;

        // Replace single image.
        replaceSingleImage(activeObject,newImageURL);

        // Replace group image.
        replaceImageInGroup(activeObject, newImageURL);
     };

     reader.readAsDataURL(file);
     // Reset input for next upload
     event.target.value = null;
   };


   // Replace Single Image.
   const replaceSingleImage = (activeObject, newImageURL) => {
  
    const imageHolder = activeObject.type === "image";

    if (!imageHolder) return;

     fabric.Image.fromURL(newImageURL, (newImg) => {
       const { left, top, angle, flipX, flipY } = activeObject;

       // Get the actual displayed width and height of the selected image
       const width = activeObject.getScaledWidth();
       const height = activeObject.getScaledHeight();

       // Resize the new image to match the original's size
       newImg.scaleToWidth(width);
       newImg.scaleToHeight(height);

       // Set properties of the new image to match the old one
       newImg.set({
         left,
         top,
         angle,
         flipX,
         flipY,
         selectable: true,
         hasControls: true,
         hasBorders: true,
       });

       // Get the index of the original image in the canvas object array
       const index = canvas.getObjects().indexOf(activeObject);
       // Remove the original image
       canvas.remove(activeObject);

       // Insert the new image at the same index (same layer position)
       canvas.insertAt(newImg, index, false); // 'false' to avoid removing other objects

       // Set the new image as active object
       canvas.setActiveObject(newImg);

        // Adjust Z-index (bring to front or send to back)
        /* if (index === 0) {
          // If it's the first object in the stack (lowest layer), bring it to the front
          newImg.bringToFront();
        } else {
          // If it's not the first object, send it to the back
          newImg.sendToBack();
        } */

        canvas.requestRenderAll();
        if (typeof canvas.fire === "function") canvas.fire("canvas:state-changed");
     });
   };
   
   // Repalce group image.
  const replaceImageInGroup = (group, newImageUrl) => {
    if (!group || group.type !== "group") {
      console.error("Provided object is not a group");
      return;
    }

    /* const groupState = {
      left: group.left,
      top: group.top,
      scaleX: group.scaleX,
      scaleY: group.scaleY,
      angle: group.angle,
      flipX: group.flipX,
      flipY: group.flipY,
      originX: group.originX,
      originY: group.originY,
      objectCaching: false,
    }; */

    const imageHolderGroup = group._objects.find((obj) => {
      return (
        obj.type === "group" &&
        obj._objects?.length === 1 &&
        obj._objects[0].type === "image"
      );
    });

    if (!imageHolderGroup) {
      console.error("Image holder group not found inside the main group");
      return;
    }

    const oldImage = imageHolderGroup._objects[0];

    if (!oldImage) {
      console.error("Old image not found inside imageHolder group");
      return;
    }

    const circleClipPath = oldImage.clipPath; // Save old clipPath

    fabric.Image.fromURL(newImageUrl, (newImg) => {
      const oldWidth = oldImage.width * oldImage.scaleX;
      const oldHeight = oldImage.height * oldImage.scaleY;

      newImg.set({
        originX: "center",
        originY: "center",
        left: 0,
        top: 0,
        scaleX: oldWidth / newImg.width,
        scaleY: oldHeight / newImg.height,
        selectable: true,
        hasControls: true,
        objectCaching: false,
        clipPath: circleClipPath ? circleClipPath : null,
      });

      imageHolderGroup.remove(oldImage);
      imageHolderGroup.add(newImg);

      // Recalculate group bounds manually
      imageHolderGroup._calcBounds();
      imageHolderGroup._updateObjectsCoords();
      imageHolderGroup.dirty = true;

      group.objectCaching = false;
      // group._calcBounds();
      // group._updateObjectsCoords();
      group.dirty = true;

      // Restore original group position
      // group.set(groupState);

      canvas.requestRenderAll();
      if (typeof canvas.fire === "function") canvas.fire("canvas:state-changed");
    });
  };


  return (
     <div style={{ marginRight: "5px" }}>
       <Button
         icon="image-rotate-right"
         text="Replace Image"
         onClick={handleReplaceClick}
       />

       {/* Hidden File Input */}
       <input
         ref={fileInputRef}
         type="file"
         accept="image/*"
         style={{ display: "none" }}
         onChange={handleReplaceImage}
       />
     </div>
   );
};
